import { localizedArray, localizedString } from '../types/customComponents'

export enum DisplayEGsBy {
  group = 'group',
  individual = 'individual',
}

export enum DisplayMenu {
  always = 'always',
  multipleEGs = 'multipleEGs',
  never = 'never',
}

export enum OrderBy {
  date = 'date',
  specific = 'specific',
}

export type TaskTrackerButtons = {
  preMenuText: localizedArray
  postMenuText: localizedArray
  button: localizedString
}

export type Conversation = {
  complete?: TaskTrackerButtons
  inProgress?: TaskTrackerButtons
  noEGs: { button: localizedString; text: localizedArray } | null
  unstarted?: TaskTrackerButtons
}

export type TaskTrackerSettings = {
  displayEGsBy: DisplayEGsBy
  displayMenu: DisplayMenu
  orderBy: OrderBy
  egOrder: string[]
  conversation: Conversation
  customRecipeOffRamp: { version: string; recipeName: string }
}

export type taskTrackerForm = {
  description: string
  name: string
  settings: TaskTrackerSettings
}

export type TaskTrackerData =
  | {
      settings: TaskTrackerSettings
    }
  | string
  | null
  | undefined
